<!--
일괄기능 — 대금상환 「정산확정 일괄처리」 (TASK-161 사이클 14 #15 — 결정 49, 송금 일괄과 같은 공용 배치 컴포넌트 job)
------------------------------------
 - 버튼 (blade) → jobInit() → 모달. 대상 = 선택 항목 (CodPaymentIndexTrait::codBatchJson 의 items)
 - 정산확정 가능 = 창고지급완료 건만 (버튼도 창고지급완료만 선택 시 활성). 다른 상태가 섞이면 안내하고 차단
 - 미리보기 = 대금상환금액 = 창고지급(실제) (소수 2자리 정확 비교 — 결정 49 e) 일치 N건 = 자동 확정 (정산확정금액 = 창고지급(실제))
             / 불일치 M건 = 이번 일괄에서 정산확정되지 않음 (서버 건별 실패) → 카드의 「정산확정」 으로 건별 처리 (결정 49 f)
 - 확인 → POST /admin/cod-payments/confirmations (ids[]) — 서버 msg + 건별 실패 목록을 alert 후 새로고침
 - 상태값 = batch.states (App\Code\CodPayment\State — 숫자 직접 비교 금지)
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-confirm-batch-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">정산확정 일괄처리</h3>

            <div class="uk-margin-small cdp-confirm-batch-summary">
                <div>선택 {{ targets.length }}건 (창고지급완료 {{ paidCount }}건)</div>
                <div class="cdp-confirm-batch-match">대금상환금액 = 창고지급(실제) <b>{{ matchCount }}건</b> — 정산확정금액 = 창고지급(실제)으로 정산확정</div>
                <div class="cdp-confirm-batch-mismatch" v-if="mismatchCount > 0">
                    대금상환금액 ≠ 창고지급(실제) <b>{{ mismatchCount }}건</b> — 이번 일괄에서는 정산확정되지 않습니다.
                    카드의 「정산확정」 버튼으로 정산확정금액을 입력해 건별로 처리해 주세요.
                </div>
                <div class="uk-text-danger cdp-confirm-batch-blocked" v-if="otherCount > 0">
                    창고지급완료가 아닌 건이 {{ otherCount }}건 섞여 있어 정산확정할 수 없습니다.
                    창고지급완료 건만 선택한 뒤 다시 진행해 주세요.
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary cdp-confirm-batch-submit" type="button"
                        :disabled="busy || otherCount > 0 || matchCount === 0" @click="submit">정산확정</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from '../../cod-payment/popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            /**
             * 일괄기능 공유data (CodPaymentIndexTrait::codBatchJson)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 항목)
                targets: [],
            };
        },
        computed: {
            paidItems() {
                let paid = parseInt(this.batch.states.paid, 10);
                return this.targets.filter((item) => parseInt(item.state, 10) === paid);
            },

            paidCount() {
                return this.paidItems.length;
            },

            // 일치 = 자동 정산확정 대상 (서버 ConfirmLogic 과 같은 소수 2자리 비교)
            matchCount() {
                return this.paidItems.filter((item) => this.sameAmount(item.req_amount, item.paid_amount)).length;
            },

            mismatchCount() {
                return this.paidCount - this.matchCount;
            },

            // 정산확정 대상이 아닌 (창고지급완료가 아닌) 선택 건수
            otherCount() {
                return this.targets.length - this.paidCount;
            },
        },
        methods: {
            /**
             * 금액 일치 — 소수 2자리 정확 비교 (App\CodPayment::sameAmount 와 같은 규칙)
             */
            sameAmount(a, b) {
                let x = this.normalize(a);
                let y = this.normalize(b);
                if (x === '' || y === '' || isNaN(parseFloat(x)) || isNaN(parseFloat(y))) {
                    return false;
                }
                return parseFloat(x).toFixed(2) === parseFloat(y).toFixed(2);
            },

            // 작업초기화 (버튼 클릭 → 모달)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 대금상환이 없습니다.');
                    return;
                }
                if (this.paidCount === 0) {
                    alert('정산확정할 수 있는 창고지급완료 건이 없습니다.');
                    return;
                }
                this.show();
            },

            submit() {
                if (this.busy || this.otherCount > 0 || this.matchCount === 0) {
                    return;
                }
                this.request('post', '/admin/cod-payments/confirmations', {
                    ids: _.map(this.paidItems, 'id'),
                }).then((response) => {
                    let msg = response && response.msg ? response.msg : '';
                    let failed = response && Array.isArray(response.failed) ? response.failed : [];
                    if (failed.length > 0) {
                        msg += '\n\n' + failed.map((f) => '- ' + (f.buy_order_code || ('#' + f.id)) + ' : ' + f.msg).join('\n');
                    }
                    this.done({msg: msg});
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 데이터 영역 강조 = 좌측 바 (배경색 변경 금지 — coding-conventions)
    .cdp-confirm-batch-summary > div {
        margin: 4px 0;
    }

    .cdp-confirm-batch-match {
        padding-left: 8px;
        border-left: 3px solid #1e87f0;
    }

    .cdp-confirm-batch-mismatch {
        padding-left: 8px;
        border-left: 3px solid #d32f2f;
        color: #b71c1c;
    }
</style>
